'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var React = require('react');
var utils = require('@chakra-ui/utils');
var react = require('@chakra-ui/react');
require('../Button/Button.js');
var IconButton = require('../Button/IconButton.js');
require('../Button/StatisticsButton.js');
var Spinner = require('../Spinner/Spinner.js');
require('../Skeleton/Skeleton.js');
var SkeletonText = require('../Skeleton/SkeletonText.js');
require('../LinkOverlay/LinkBox.js');
var LinkOverlay = require('../LinkOverlay/LinkOverlay.js');
require('../../icons/AccountAdd.js');
require('../../icons/AccountCheck.js');
require('../../icons/AccountRemove.js');
require('../../icons/AccountStar.js');
require('../../icons/Account.js');
require('../../icons/ArrowCollapse.js');
require('../../icons/ArrowDownDrop.js');
require('../../icons/ArrowExpand.js');
require('../../icons/ArrowLeftDrop.js');
require('../../icons/ArrowLeft.js');
require('../../icons/ArrowRightDrop.js');
require('../../icons/Bell.js');
require('../../icons/BullhornOutline.js');
require('../../icons/BurgerMenu.js');
require('../../icons/CalendarDetailed.js');
require('../../icons/CalendarOutline.js');
require('../../icons/CashOff.js');
require('../../icons/Cash.js');
require('../../icons/CautionDecagram.js');
require('../../icons/CautionOutline.js');
require('../../icons/CheckCircled.js');
require('../../icons/CheckDecagram.js');
require('../../icons/CheckOutlinedCircled.js');
require('../../icons/Check.js');
require('../../icons/ChevronDown.js');
require('../../icons/ChevronLeft.js');
require('../../icons/ChevronRight.js');
require('../../icons/ChevronUp.js');
require('../../icons/CircleOutline.js');
require('../../icons/ClipboardTextOutline.js');
require('../../icons/Clock.js');
require('../../icons/CloseCircleFilled.js');
require('../../icons/Close.js');
require('../../icons/CompareArrows.js');
require('../../icons/Corner.js');
require('../../icons/Critical.js');
var Delete = require('../../icons/Delete.js');
require('../../icons/DocumentEditCircled.js');
require('../../icons/DocumentEditOutline.js');
require('../../icons/DotsVertical.js');
require('../../icons/DownloadFilled.js');
var Draft = require('../../icons/Draft.js');
require('../../icons/Encryption.js');
require('../../icons/EuroOff.js');
require('../../icons/Euro.js');
require('../../icons/EyeOff.js');
require('../../icons/Eye.js');
require('../../icons/FlagCheckered.js');
require('../../icons/FwSet0Constructionyear1.js');
require('../../icons/FwSet0Constructionyear2.js');
require('../../icons/FwSet0Constructionyear3.js');
require('../../icons/FwSet0Constructionyear4.js');
require('../../icons/FwSet0Corner.js');
require('../../icons/FwSet0Corneretc.js');
require('../../icons/FwSet0CultivableLimited.js');
require('../../icons/FwSet0CultivableNo.js');
require('../../icons/FwSet0CultivableUnsure.js');
require('../../icons/FwSet0Cultivable.js');
require('../../icons/FwSet0ElevatorNo.js');
require('../../icons/FwSet0Elevator.js');
require('../../icons/FwSet0Flat.js');
require('../../icons/FwSet0Garage.js');
require('../../icons/FwSet0House.js');
require('../../icons/FwSet0IndustryDontKnow.js');
require('../../icons/FwSet0IndustryIndustry.js');
require('../../icons/FwSet0IndustryLiveBusiness.js');
require('../../icons/FwSet0IndustryOffice.js');
require('../../icons/FwSet0Industry.js');
require('../../icons/FwSet0KitchenNew.js');
require('../../icons/FwSet0KitchenNo.js');
require('../../icons/FwSet0KitchenOld.js');
require('../../icons/FwSet0LandDevelopmentFull.js');
require('../../icons/FwSet0LandDevelopmentInPart.js');
require('../../icons/FwSet0LandDevelopmentNo.js');
require('../../icons/FwSet0Level1.js');
require('../../icons/FwSet0Level2.js');
require('../../icons/FwSet0Level3.js');
require('../../icons/FwSet0Levelplus.js');
require('../../icons/FwSet0LivingspaceUnknown.js');
require('../../icons/FwSet0Livingspace100.js');
require('../../icons/FwSet0Livingspace200.js');
require('../../icons/FwSet0Livingspace200Plus.js');
require('../../icons/FwSet0ParkingNo.js');
require('../../icons/FwSet0Parking.js');
require('../../icons/FwSet0PlotUnknown.js');
require('../../icons/FwSet0Plot.js');
require('../../icons/FwSet0Plot1000.js');
require('../../icons/FwSet0Plot1000Plus.js');
require('../../icons/FwSet0Plot300.js');
require('../../icons/FwSet0Rooms.js');
require('../../icons/FwSet0SemiDetached.js');
require('../../icons/FwSet0TownhouseCorner.js');
require('../../icons/FwSet0TownhouseMiddle.js');
require('../../icons/GiftCircled.js');
require('../../icons/Hausgold.js');
require('../../icons/HelpOutline.js');
require('../../icons/Help.js');
require('../../icons/HomeOutline.js');
require('../../icons/HouseCircled.js');
require('../../icons/HousePerson.js');
require('../../icons/House.js');
require('../../icons/Industry.js');
require('../../icons/InfoFilled.js');
require('../../icons/InfoOutline.js');
require('../../icons/LabelPercent.js');
require('../../icons/Level2.js');
require('../../icons/LightbulbOn.js');
require('../../icons/LockCircledOutline.js');
require('../../icons/Lock.js');
require('../../icons/Magnifier.js');
require('../../icons/Mail.js');
require('../../icons/Map.js');
require('../../icons/MissingOutline.js');
require('../../icons/OkCircled.js');
require('../../icons/OpenBookOutline.js');
require('../../icons/PageFirst.js');
require('../../icons/PageLast.js');
require('../../icons/Pause.js');
require('../../icons/Pen.js');
require('../../icons/Percent.js');
require('../../icons/PhoneCircled.js');
require('../../icons/Phone.js');
require('../../icons/PiggyBankCircled.js');
require('../../icons/PiggyBank.js');
require('../../icons/Plus.js');
require('../../icons/PremiumStars.js');
require('../../icons/Printer.js');
require('../../icons/RealtyCommercial.js');
require('../../icons/RealtyFlat.js');
require('../../icons/RealtyHouse.js');
require('../../icons/RealtySite.js');
require('../../icons/Rocket.js');
require('../../icons/Rooms.js');
require('../../icons/SpeechBubble.js');
require('../../icons/SpeechBubbles.js');
require('../../icons/Speedometer.js');
require('../../icons/Star.js');
require('../../icons/StatusDontknow.js');
require('../../icons/SwapHorizontalBold.js');
require('../../icons/ThumbDownOutline.js');
require('../../icons/ThumbUpOutline.js');
require('../../icons/TruckFastOutline.js');
require('../../icons/UnorderedList.js');
require('../../icons/User.js');
require('../InputFile/InputFile.js');
var utils$1 = require('../InputFile/utils.js');
var useInputFileUtils = require('../InputFile/useInputFileUtils.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["value", "onDelete", "deleteButtonProps", "deleteButtonAriaLabel", "isLoading", "isDisabled", "width", "normalizeCustomType", "isCustomType"];
/**
 * File component
 *
 * Displays preview for a file. Accepts *either* a native {@link File|File} instance
 * or a {@link AssetLike|custom file data}.
 *
 * @param props - {@link FileProps}
 * @param ref - React ref to the root element
 * @constructor
 */
function File(props, ref) {
  var value = props.value,
    onDeleteProp = props.onDelete,
    deleteButtonProps = props.deleteButtonProps,
    _props$deleteButtonAr = props.deleteButtonAriaLabel,
    deleteButtonAriaLabel = _props$deleteButtonAr === void 0 ? 'Löschen' : _props$deleteButtonAr,
    isLoadingProp = props.isLoading,
    isDisabledProp = props.isDisabled,
    _props$width = props.width,
    width = _props$width === void 0 ? 24 : _props$width,
    _props$normalizeCusto = props.normalizeCustomType,
    normalizeCustomType = _props$normalizeCusto === void 0 ? utils$1.normalizeCustomType : _props$normalizeCusto,
    _props$isCustomType = props.isCustomType,
    isCustomType = _props$isCustomType === void 0 ? utils$1.isCustomType : _props$isCustomType,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _React$useState = React__default["default"].useState(isLoadingProp),
    _React$useState2 = _slicedToArray__default["default"](_React$useState, 2),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var assetLike = React.useMemo(function () {
    var utils = new useInputFileUtils.UseInputFileUtils(normalizeCustomType, isCustomType);
    return utils.computeAssetLike(value);
  }, [value, normalizeCustomType, isCustomType]);
  var styles = react.useMultiStyleConfig('File', {
    width: width,
    isLoading: isLoading,
    assetLike: assetLike
  });
  if (!assetLike) {
    return null;
  }
  var isDisabled = isLoading || isDisabledProp;
  var showDeleteButton = !!onDeleteProp && !isLoading;
  var hasUrl = !!assetLike.fileUrl;
  var onDelete = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(event) {
      return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.stopPropagation();
              _context.prev = 1;
              setIsLoading(true);
              _context.next = 5;
              return onDeleteProp === null || onDeleteProp === void 0 ? void 0 : onDeleteProp(event);
            case 5:
              _context.prev = 5;
              setIsLoading(false);
              return _context.finish(5);
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 5, 8]]);
    }));
    return function onDelete(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React__default["default"].createElement(react.Box, _extends__default["default"]({
    role: "group",
    "aria-busy": isLoading,
    "data-disabled": utils.ariaAttr(isDisabled),
    "data-url": utils.dataAttr(hasUrl),
    "aria-label": assetLike.filename || undefined,
    __css: styles.box,
    ref: ref
  }, rest), /*#__PURE__*/React__default["default"].createElement(react.LinkBox, null, /*#__PURE__*/React__default["default"].createElement(LinkOverlay.LinkOverlay, {
    variant: "unstyled",
    role: assetLike.fileUrl ? "link" : undefined,
    as: assetLike.fileUrl ? "a" : "div",
    href: assetLike.fileUrl || undefined,
    sx: styles.container,
    title: assetLike.title,
    target: "_blank",
    rel: "noopener"
  }, /*#__PURE__*/React__default["default"].createElement(react.Box, {
    as: "span",
    __css: styles.icon
  }, isLoading ? /*#__PURE__*/React__default["default"].createElement(Spinner.Spinner, {
    color: "gray.300"
  }) : /*#__PURE__*/React__default["default"].createElement(Draft.Draft, {
    w: "full",
    h: "full"
  }))), (isLoading || assetLike.filename) && /*#__PURE__*/React__default["default"].createElement(react.Box, {
    __css: styles.textContainer
  }, /*#__PURE__*/React__default["default"].createElement(SkeletonText.SkeletonText, {
    skeletonHeight: '1.125rem',
    startColor: "gray.100",
    endColor: "gray.200",
    noOfLines: 1,
    isLoaded: !isLoading
  }, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    "data-testid": "fileName",
    sx: styles.text,
    noOfLines: 1
  }, assetLike.filename)))), showDeleteButton && /*#__PURE__*/React__default["default"].createElement(IconButton.IconButton, _extends__default["default"]({
    onClick: onDelete,
    isDisabled: isDisabled,
    size: "md",
    variant: "unstyled",
    sx: styles.deleteButton,
    "aria-label": deleteButtonAriaLabel,
    icon: /*#__PURE__*/React__default["default"].createElement(Delete.Delete, null)
  }, deleteButtonProps)));
}
var _File = react.forwardRef(File);

// https://github.com/mobxjs/mobx-react/issues/352#issuecomment-341861198
_File.displayName = 'File';
exports.File = _File;